import React from "react";

const TopProfileBar = ({ children, darkMode }) => (
  <div
    className={`fixed top-0 left-0 right-0 z-40 flex items-center justify-end h-16 px-4 border-b-2 ${
      darkMode ? "bg-gray-800 border-gray-600" : "bg-white border-gray-200"
    }`}
    style={{ minHeight: 64 }}
  >
    {children}
  </div>
);

export default TopProfileBar;
